import { useColors } from '@inbody/core';
import { InlineLoading } from '@inbody/ui';
import { Box } from '@mui/material';

import { CONTENT_HEIGHT } from '../../layout/layoutSize';

type LoadingProps = {
  /** 안내 문구. 기본은 '데이터를 불러오고 있습니다.' */
  label?: string;
  /** 페이지 전체를 기다릴 때. 레이아웃의 내용 영역 가운데에 놓는다. */
  page?: boolean;
  /** 패널 안에서의 최소 높이. page 면 쓰지 않는다. */
  minHeight?: number | string;
};

/**
 * 이 앱의 로딩 표시 — 화면·패널이 데이터를 기다리는 동안 모두 이것을 쓴다.
 * 0.2초 뒤에 나타나서, 금방 끝나는 로딩에서는 스피너가 깜빡이지 않는다.
 */
export const Loading = ({
  label,
  page = false,
  minHeight = 160,
}: LoadingProps) => {
  const { brand } = useColors();
  return (
    <Box
      sx={{
        flex: 1,
        // InlineLoading 의 스피너는 부모 글자색을 따른다.
        color: brand[500],
        animation: 'loading-fade-in 0.2s ease 0.2s both',
        '@keyframes loading-fade-in': {
          from: { opacity: 0 },
          to: { opacity: 1 },
        },
      }}
    >
      <InlineLoading
        label={label}
        minHeight={page ? CONTENT_HEIGHT : minHeight}
      />
    </Box>
  );
};
